export function computeEffectiveNavbarHeight(baseHeight, { phoneOnly, statusBarOverlay, statusBarInsetPx, isRegisterPage }) {
    let height = baseHeight;
    if (isRegisterPage) {
        return height;
    }
    if (phoneOnly) {
        height -= 7;
    }
    if (statusBarOverlay) {
        height += statusBarInsetPx + 2;
    }
    return height;
}

export default {
    appData(){
        return this.$store.state.globalModule.appData;
    },
    user(){
        return this.$store.state.userModule.user;
    },
    platform(){
        return process.env.VUE_APP_PLATFORM;
    },
    isProduction(){
        return process.env.NODE_ENV === "production";
    },
    capRunning(){
        return this.platform !== 'web';
    },    
    androidSdkInt(){
        if (typeof window === 'undefined' || window.__ANDROID_SDK_INT__ == null) {
            return null;
        }
        const n = Number(window.__ANDROID_SDK_INT__);
        return Number.isFinite(n) ? n : null;
    },
    /** Android 15+ (API 35), phone layout only — matches edge-to-edge inset issues. */
    androidNeedsSafeArea(){
        let envValue = process.env.VUE_APP_ENABLE_ANDROID_SAFE_AREA;
        envValue = envValue === true || envValue === 'true';
        return this.platform === 'android' && this.capRunning &&
            this.androidSdkInt != null && this.androidSdkInt >= 35 && envValue;
    },
    statusBarOverlay(){
        if (!this.capRunning) {
            return false;
        }
        if (this.platform === 'ios') {
            return true;
        }
        return this.androidNeedsSafeArea;
    },
    bottomSafeArea(){
        if (!this.capRunning) {
            return false;
        }
        if (this.platform === 'ios') {
            return true;
        }
        return this.androidNeedsSafeArea;
    },
    statusBarInsetPx(){
        return 45;
    },
    navbarBaseHeight(){
        return 65;
    },
    effectiveNavbarHeight(){
        return computeEffectiveNavbarHeight(this.navbarBaseHeight, {
            phoneOnly: this.phoneOnly,
            statusBarOverlay: this.statusBarOverlay,
            statusBarInsetPx: this.statusBarInsetPx,
            isRegisterPage: ['login', 'register', 'reset-password'].includes(this.$route.name),
        });
    },
    bottomSafeInsetPx(){
        return this.platform === 'android' ? 34 : 20;
    },
    webDesktop(){
        return this.platform === 'web' && this.pcOnly;
    },
    wpEnabled(){
        const enable_wp = this.appData.enable_wp;
        let wpEnabled = false;
        if (this.webPhone){
            wpEnabled = enable_wp === 'all' || enable_wp === 'all_with_desktop' || (enable_wp === 'ios' && this.isWebIOS);
        }else if (this.webDesktop){
            wpEnabled = enable_wp === 'desktop' || enable_wp === 'all_with_desktop';
        }
        return wpEnabled;
    },
    webPhone(){
        return this.platform === 'web' && this.phoneOnly;
    },
    isWebIOS(){
        if (this.capRunning){
            return false
        }
        var isIOS = /iPad|iPhone|iPod|webOS/.test(navigator.userAgent);
        return isIOS;
    },
    miniDerasaPlatform(){
        const mini = process.env.VUE_APP_MINI_DERASATECH_PLATFORM;
        return mini === 'true' || mini === true;
    },
    appLoadedOnce(){
        return this.$store.state.loaded;
    },
    innerApp(){
        return this.isAuthed && this.$route.meta.requiresAuth && this.$route.name !== 'confirm';
    },
    pcOnly(){
        return this.$vuetify.breakpoint.mdAndUp;
    },
    mdAndUp(){
        return this.$vuetify.breakpoint.smAndUp;
    },
    phoneOnly(){
        return !this.pcOnly;
    },
    phoneAndTablet(){
        return this.$vuetify.breakpoint.mdAndDown;
    },
    isAuthed(){
        return !!this.$store.state.userModule.user;
    },
    isAdmin(){
        return this.user ? this.user.groupId == 1 : false;
    },
    isLeader(){
        return this.user ? this.user.groupId == 2 : false;
    },
    isDark() {
        return this.$vuetify.theme.dark;
    }
}